import Typography from "@mui/material/Typography";

import colors from "../../styles/colors/colors";
import { LOGOUT_SUCCESS_MESSAGE } from "../../constants/ApplicationUrl";
import { LogoutCard, LogoutLayout } from "./style";

const Logout = () => {
  return (
    <LogoutLayout container>
      <LogoutCard>
        <Typography
          variant="h2"
          color={colors.fonts[5]}
          fontSize="1.1rem"
          fontWeight="400"
          textAlign="center"
        >
          {LOGOUT_SUCCESS_MESSAGE}
        </Typography>
      </LogoutCard>
    </LogoutLayout>
  );
};

export default Logout;